var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstantAnswerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Question",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Question",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12a1 1 0 11-2 0 1 1 0 012 0zM7 6c0-.544.433-1 1-1s1 .456 1 1c0 .445-.182.82-.498 1.192-.255.3-.53.527-.827.774-.107.089-.217.18-.33.278a1 1 0 101.31 1.512c.057-.05.127-.108.208-.175.315-.26.782-.646 1.162-1.093C10.534 7.89 11 7.07 11 6c0-1.605-1.285-3-3-3S5 4.395 5 6a1 1 0 002 0z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zm0-2A6 6 0 108 2a6 6 0 000 12z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgInstantAnswerIcon;